{
  "common": {
    "search": "بحث...",
    "filter": "تصفية",
    "all": "الكل",
    "actions": "الإجراءات",
    "view": "عرض",
    "viewDetails": "عرض التفاصيل",
    "edit": "تعديل",
    "delete": "حذف",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "saveChanges": "حفظ التغييرات",
    "download": "تحميل",
    "print": "طباعة",
    "status": "الحالة",
    "date": "التاريخ",
    "amount": "المبلغ",
    "total": "الإجمالي",
    "currency": "العملة",
    "notes": "ملاحظات",
    "loading": "جارٍ التحميل...",
    "noData": "لا توجد بيانات متاحة",
    "success": "تمت العملية بنجاح",
    "error": "حدث خطأ",
    "close": "إغلاق",
    "submit": "إرسال",
    "branch": "الفرع التشغيلي",
    "previous": "السابق",
    "next": "التالي",
    "critical": "حرج",
    "active": "نشط",
    "target": "الهدف",
    "completed": "مكتمل",
    "finalized": "منتهي",
    "inProgress": "قيد المعالجة",
    "pastDue": "مستحق السداد",
    "voided": "ملغي",
    "corporate": "شركات",
    "current": "الحالي",
    "statusApproved": "معتمد",
    "statusDraft": "مسودة",
    "statusPending": "قيد الانتظار",
    "statusOverdue": "متأخر السداد",
    "statusPaid": "مدفوع بالكامل",
    "statusPartial": "سداد جزئي",
    "statusDeposit": "تم سداد العربون",
    "statusCancelled": "ملغي",
    "statusRejected": "مرفوض",
    "statusTentative": "مبدئي",
    "statusConfirmed": "مؤكد",
    "updatedBy": "تم التحديث بواسطة",
    "close": "إغلاق",
    "yes": "نعم",
    "no": "لا",
    "downloadImage": "تحميل الصورة",
    "selected": "محدد",
    "exportSelected": "تصدير المحدد",
    "deleteSelected": "حذف المحدد",
    "noFile": "لا يوجد ملف",
    "done": "تم",
    "refresh": "تحديث",
    "copied": "تم النسخ!",
    "copiedConfirmation": "تم نسخ رقم التأكيد بنجاح",
    "generateReceipt": "إنشاء إيصال",
    "generateDepositReceipt": "إصدار إيصال عربون مباشر",
    "directDepositReceipt": "إيصال عربون مباشر",
    "viewStandaloneReceipts": "عرض قائمة الإيصالات المباشرة",
    "downloadReceipt": "تحميل الإيصال",
    "officialReceipt": "إيصال رسمي",
    "depositReceipt": "إيصال عربون",
    "receiptNo": "رقم الإيصال"
  },
  "nav": {
    "overview": "نظرة عامة",
    "external": "خارجي",
    "internal": "داخلي",
    "others": "أخرى",
    "dashboard": "لوحة التحكم",
    "confirmations": "التأكيدات",
    "invoices": "التأكيدات",
    "requests": "طلبات الاعتماد",
    "companies": "الشركات",
    "hotelReservations": "حجوزات الفنادق",
    "myExpenses": "مصاريفي",
    "submitExpense": "تقديم مصروف",
    "approvals": "الموافقات",
    "settings": "الإعدادات",
    "superAdmin": "المشرف العام",
    "comingSoon": "قريباً"
  },
  "header": {
    "operatingBranch": "الفرع التشغيلي:",
    "notifications": "الإشعارات",
    "all": "الكل",
    "systemLog": "سجل النظام",
    "markAllRead": "تحديد الكل كمقروء",
    "noNotifications": "لا توجد إشعارات حالياً في هذا القسم.",
    "settings": "الإعدادات",
    "switchAccount": "تبديل الحساب",
    "language": "اللغة",
    "superAdminDashboard": "لوحة تحكم المشرف العام",
    "logOut": "تسجيل الخروج"
  },
  "dashboard": {
    "welcome": "مرحباً",
    "systemName": "نظام الإدارة المالية لمجموعة ODST",
    "totalRevenue": "إجمالي الإيرادات",
    "totalConfirmations": "إجمالي التأكيدات",
    "pendingApprovals": "بانتظار الاعتماد",
    "outstandingBalance": "الرصيد القائم المستحق",
    "overdueBalance": "المبالغ المتأخرة",
    "recentConfirmations": "أحدث التأكيدات",
    "seeAllConfirmations": "عرض كافة التأكيدات",
    "approvalQueue": "قائمة طلبات الاعتماد",
    "awaitingReview": "قيد المراجعة والتدقيق",
    "actionRequired": "مطلوب اتخاذ إجراء",
    "branchPerformance": "أداء الفروع",
    "revenueShare": "نسبة مساهمة الإيرادات",
    "revenueShareLabel": "نسبة مساهمة الإيرادات",
    "monthlyRevenueTrend": "مؤشر الإيرادات الشهري",
    "quarterlyGrowth": "معدل النمو الربع سنوي",
    "ref": "رقم المرجع",
    "client": "الشركة / العميل",
    "confDate": "تاريخ التأكيد",
    "dueDate": "تاريخ الاستحقاق",
    "acrossAllOffices": "في كافة المكاتب والفروع النشطة",
    "activeLedgerRecords": "سجلات الدفتر المالي النشطة",
    "requiresReview": "تتطلب المراجعة",
    "pendingSettlement": "بانتظار السداد والتسوية",
    "overdueConfirmation": "تأكيد متأخر السداد",
    "overdueConfirmations": "تأكيدات متأخرة السداد",
    "financialReport": "التقرير المالي",
    "performanceSummary": "ملخص الأداء",
    "growthQoQ": "النمو (مقارنة ربع سنوية)",
    "outstanding": "المبالغ المعلقة (المستحقة)",
    "quarterlyFinancialComparison": "المقارنة المالية الفصلية",
    "metric": "المعيار المالي",
    "change": "التغير",
    "revenue": "الإيرادات",
    "netProfit": "صافي الأرباح",
    "profitMargin": "هامش الربح",
    "invoiceDistributionOverview": "نظرة عامة على توزيع الفواتير",
    "totalSent": "إجمالي المرسل",
    "dataConsolidatedFor": "البيانات موحدة لـ",
    "exportPdfReport": "تصدير تقرير PDF"
  },
  "invoices": {
    "title": "دفتر تأكيدات الحجز",
    "subtitle": "متابعة الدفعات المقدمة، وسجلات العربون، وجدولة الأقساط، وإدارة الأرصدة الدائنة الفائضة.",
    "createConfirmation": "إنشاء تأكيد جديد",
    "exportCsv": "تصدير ملف CSV",
    "batchDelete": "حذف العناصر المحددة",
    "searchPlaceholder": "البحث برقم المرجع، اسم العميل، أو الشركة...",
    "recentApprovedConfirmations": "أحدث التأكيدات المعتمدة",
    "allBranches": "كافة الفروع",
    "allStatuses": "كافة الحالات",
    "allCompanies": "كافة الشركات",
    "awaitingClearance": "بانتظار المقاصة",
    "clearedSubtext": "تمت المعالجة والتسوية بنجاح",
    "serialNo": "الرقم التسلسلي",
    "paidAmount": "المبلغ المسدد",
    "remaining": "المبلغ المتبقي",
    "advancePayment": "الدفعة المقدمة (العربون)",
    "addPayment": "تسجيل سند سداد",
    "paymentHistory": "سجل المدفوعات السابقة",
    "recordNewPayment": "تسجيل دفعة جديدة",
    "paymentDate": "تاريخ السداد",
    "paymentProof": "إيصال التحويل البنكي",
    "creditBalanceExcess": "ترحيل المبلغ الفائض كرصيد دائن للعميل",
    "itemizedCharges": "تفاصيل بنود الخدمة",
    "serviceDescription": "بيان الخدمة",
    "unitPrice": "سعر الوحدة",
    "qty": "الكمية",
    "subtotal": "المجموع الفرعي",
    "showing": "عرض",
    "of": "من أصل",
    "approvedInvoices": "تأكيد معتمد",
    "confirmationDetails": "تفاصيل التأكيد المالي",
    "reviewBillingDetails": "مراجعة تفاصيل الفاتورة والحساب",
    "generateNewConfirmation": "إنشاء تأكيد جديد",
    "editConfirmation": "تعديل التأكيد",
    "modifyConfirmationSubtitle": "تعديل تفاصيل التأكيد قبل إعادة التقديم",
    "confirmationNumber": "رقم التأكيد",
    "referenceNumber": "الرقم المرجعي",
    "serialNumber": "الرقم التسلسلي",
    "confirmationDate": "تاريخ التأكيد",
    "dueDate": "تاريخ الاستحقاق",
    "billFrom": "فاتورة من",
    "billTo": "فاتورة إلى",
    "clientCompany": "شركة العميل",
    "clientSelection": "اختيار اسم الشركة / العميل",
    "selectClientCompany": "اختر شركة العميل...",
    "pleaseSelectCompany": "يرجى تحديد الشركة",
    "entityCompany": "الجهة / الشركة",
    "companyTaxNumber": "الرقم الضريبي للشركة",
    "streetAddress": "عنوان الشارع",
    "cityCountry": "المدينة / الدولة",
    "phone": "رقم الهاتف",
    "description": "الوصف",
    "itemizedCharges": "تفاصيل الرسوم والخدمات",
    "itemDescription": "وصف الخدمة",
    "qty": "الكمية",
    "unitPrice": "سعر الوحدة",
    "total": "المجموع",
    "subtotal": "المجموع الفرعي",
    "totalDue": "إجمالي المستحق",
    "taxVat": "الضريبة / القيمة المضافة",
    "hasAdvancePayment": "هل توجد دفعة مقدمة (عربون)؟",
    "advancePaymentAmount": "مبلغ الدفعة المقدمة",
    "selectService": "اختيار الخدمة",
    "chooseConfiguredService": "اختر الخدمة المحددة...",
    "addCustomItem": "إضافة بند مخصص",
    "paymentInstructions": "تعليمات السداد والتحويل",
    "bankName": "اسم البنك",
    "accountName": "اسم الحساب",
    "idrAccountNumber": "رقم حساب الروبية (IDR)",
    "usdAccountNumber": "رقم حساب الدولار (USD)",
    "bankBranchAddress": "عنوان فرع البنك",
    "cifNumber": "رقم تعريف العميل / الشركة (CIF)",
    "swiftCode": "رمز سويفت (SWIFT)",
    "notes": "ملاحظات",
    "termsAndConditions": "الشروط والأحكام",
    "systemStatus": "حالة النظام",
    "viewPaymentProof": "عرض إشعار التحويل",
    "uploadProof": "رفع الإشعار",
    "print": "طباعة",
    "downloadPdf": "تحميل PDF",
    "verifying": "جاري التحقق...",
    "errorsFound": "أخطاء موجودة. يرجى تصحيحها قبل الإرسال.",
    "dueDateFuture": "يجب أن يكون تاريخ الاستحقاق في المستقبل",
    "validationFailed": "فشل التحقق: يرجى تصحيح الأخطاء للمتابعة",
    "formStatusValid": "حالة النموذج: مكتمل وصحيح",
    "saveAndResubmit": "حفظ وإعادة الإرسال",
    "generateConfirmation": "إصدار التأكيد",
    "currency": "العملة",
    "noCompaniesAvailable": "لا توجد شركات متاحة. يرجى إضافة شركة في الإعدادات أو صفحة الشركات أولاً.",
    "agent": "الوكيل (Agent)",
    "othersClient": "عميل مخصص / آخرون (Others)",
    "customClientInfo": "عميل مؤقت (لا يحفظ في البيانات الرئيسية)",
    "customCompanyNameRequired": "اسم شركة العميل مطلوب",
    "additionalInformation": "معلومات إضافية (اختياري)",
    "additionalInformationDesc": "تفاصيل اختيارية لرقم المجموعة والجنسية.",
    "groupNumber": "رقم المجموعة",
    "groupNumberPlaceholder": "مثال GRP-2026-JKT01",
    "nationality": "الجنسية",
    "nationalityPlaceholder": "مثال إندونيسي / سعودي",
    "paymentHistoryTitle": "سجل الدفع وإدارة الرصيد",
    "confirmation": "تأكيد",
    "totalBilled": "إجمالي الفاتورة",
    "totalPaid": "إجمالي المدفوع",
    "remainingDue": "المبلغ المتبقي",
    "installmentsLedger": "دفتر الأستاذ للأقساط",
    "addPayment": "إضافة دفعة",
    "addPaymentApprovalNote": "🔒 إضافة الدفعة تتاح بعد الموافقة من المستوى 4",
    "date": "التاريخ",
    "amount": "المبلغ",
    "recordedBy": "سُجل بواسطة",
    "proof": "الإثبات",
    "viewProof": "عرض الإثبات",
    "noInstallmentsRecorded": "لم يتم تسجيل أي مدفوعات أقساط حتى الآن.",
    "editPaymentRecord": "تعديل سجل الدفع",
    "recordNewPayment": "تسجيل دفعة جديدة",
    "paymentAmount": "مبلغ الدفعة",
    "enterAmountPaid": "أدخل المبلغ المدفوع...",
    "paymentDate": "تاريخ الدفع",
    "uploadPaymentProof": "تحميل إثبات الدفع (إيصال التحويل)",
    "attachProofFile": "إرفاق ملف الإثبات (صورة/PDF)...",
    "paymentNote": "ملاحظة الدفع (اختياري)",
    "paymentNotePlaceholder": "مثال: تحويل بنكي، رقم الإيصال المرجعي...",
    "overpaymentDetected": "تم اكتشاف فائض في الدفع (+{{amount}})",
    "saveExcessCredit": "حفظ الفائض كرصيد دائن لصالح {{company}}؟",
    "savePayment": "حفظ الدفعة",
    "deletePaymentConfirmTitle": "حذف سجل الدفع؟",
    "deletePaymentConfirmDesc": "هل أنت متأكد أنك تريد حذف سجل الدفع هذا؟ سيتم إعادة حساب المبلغ المتبقي تلقائياً.",
    "uploadingPaymentProof": "جارٍ تحميل إثبات الدفع",
    "convertingImage": "جارٍ تحويل الصورة والتحميل إلى الخادم. يرجى الانتظار...",
    "paymentProofViewerTitle": "صورة إثبات التحويل / PDF",
    "downloadImage": "تنزيل الصورة",
    "confirmationAutoApproved": "تم اعتماد التأكيد تلقائياً",
    "bypassApprovedDesc": "تم تفعيل التجاوز المباشر. تم اعتماد التأكيد وجاهز للتحميل.",
    "confirmationGeneratedSuccess": "تم إنشاء التأكيد بنجاح",
    "confirmationGeneratedDesc": "تم إنشاء التأكيد بنجاح. هل ترغب في إرسال طلب للحصول على موافقة السداد؟",
    "noThanks": "لا، شكراً",
    "sendRequest": "إرسال الطلب",
    "requestSentSuccess": "تم إرسال الطلب بنجاح",
    "requestSentDesc": "تم إرسال طلب الاعتماد بنجاح. سيتم إشعارك فور اعتماده.",
    "viewPdf": "عرض / PDF"
  },
  "requests": {
    "title": "طلبات الاعتماد المالي",
    "subtitle": "مراجعة واعتماد أو رفض طلبات التأكيدات والفواتير متعددة المستويات الإدارية.",
    "allRequests": "كافة الطلبات",
    "allRequestsListing": "قائمة كافة طلبات التأكيد",
    "myApprovals": "طلبات بانتظار اعتمادي",
    "approved": "الطلبات المعتمدة",
    "rejected": "الطلبات المرفوضة",
    "searchPlaceholder": "البحث في الطلبات أو الشركات...",
    "level1": "رئيس الحسابات (L1)",
    "level2": "المعتمد المختص (L2)",
    "level3": "مدير إدارة العمرة (L3)",
    "level4": "المراقب المالي (L4)",
    "approve": "اعتماد ومتابعة",
    "reject": "رفض الطلب",
    "approvalNote": "ملاحظات الاعتماد",
    "rejectionReason": "سبب الرفض",
    "provideReason": "يرجى توضيح سبب الرفض بالتفصيل",
    "submittedBy": "مُقدَّم من",
    "submissionDate": "تاريخ التقديم",
    "showing": "عرض",
    "of": "من أصل",
    "totalRequests": "إجمالي الطلبات",
    "fullyApprovedBanner": "تم اعتماد هذه الفاتورة بالكامل وهي جاهزة للدفع. تم استيفاء جميع التوقيعات اللازمة.",
    "rejectedConfirmationDetails": "تفاصيل التأكيد المرفوض",
    "fullyApprovedConfirmationDetails": "تفاصيل التأكيد المعتمد بالكامل",
    "reviewRequest": "مراجعة الطلب",
    "confirmationRequests": "طلبات التأكيد",
    "requestNumber": "الطلب",
    "backToListing": "العودة إلى القائمة",
    "approvalWorkflow": "مخطط سير الاعتماد",
    "approvalWorkflowStatus": "حالة سير الاعتماد",
    "awaitingReview": "بانتظار المراجعة",
    "pending": "قيد الانتظار",
    "chiefAccountant": "رئيس المحاسبين (Chief Accountant)",
    "level2Approvers": "معتمدو المستوى الثاني",
    "level3Approvers": "معتمدو المستوى الثالث",
    "umrahDivisionDirector": "مدير قطاع العمرة (Division Director)",
    "financialController": "المدير المالي (Financial Controller)",
    "approvalsComplete": "اكتملت الاعتمادات",
    "readyForPayment": "جاهز لتنفيذ الدفع.",
    "requestRejected": "تم رفض الطلب",
    "approvalsProgress": "اكتمل {{count}} من أصل 4 اعتمادات",
    "pendingLevelAction": "بانتظار إجراء المستوى {{level}} قبل المتابعة.",
    "waitingForLevel": "بانتظار اعتماد المستوى {{level}}",
    "awaitingReviewYourLevel": "بانتظار المراجعة (مستواك الإداري)",
    "paymentTransferPhoto": "صورة إيصال التحويل المالي",
    "paymentProofPdf": "مستند إثبات الدفع (PDF)",
    "clickToViewPdf": "انقر لعرض مستند PDF",
    "clickToViewFullSize": "🔍 انقر لعرض بالحجم الكامل",
    "deleteProof": "حذف الإثبات",
    "changeDocument": "تغيير المستند",
    "noProofUploaded": "لم يتم رفع أي مستند لإثبات الدفع حتى الآن.",
    "uploadProofPdfImg": "رفع إثبات الدفع (PDF/صورة)",
    "availableOperations": "الإجراءات والعمليات المتاحة",
    "reviewPaymentInstructions": "أستاذ عماد، يرجى مراجعة إثبات الدفع المرفق أدناه. إذا كان الإثبات صحيحاً، يرجى اعتماد عملية الدفع.",
    "rejectPayment": "رفض عملية الدفع",
    "approvePayment": "اعتماد عملية الدفع",
    "awaitingPaymentApprovalNotice": "تم رفع إثبات الدفع وتقديمه. بانتظار الاعتماد من الأستاذ عماد مصطفى.",
    "markedAsPaid": "محدد كمدفوع",
    "executePayment": "تنفيذ الدفع",
    "submitPaymentForApproval": "إرسال الدفع للاعتماد",
    "sendConfirmation": "إرسال التأكيد",
    "printConfirmation": "طباعة التأكيد",
    "downloadPdf": "تحميل PDF",
    "editAndResubmit": "تعديل وإعادة تقديم",
    "archiveConfirmation": "أرشفة التأكيد",
    "decisionInfo": "يرجى مراجعة جميع التفاصيل بعناية قبل اتخاذ القرار. لا يمكن التراجع عن هذا الإجراء.",
    "yourDecision": "قرارك الإداري (المستوى {{level}})",
    "decisionSubtitle": "بصفتك {{role}}، قم بالموافقة على طلب التأكيد هذا أو رفضه.",
    "approvalNoteOptional": "ملاحظات الاعتماد (اختياري)",
    "addNotePlaceholder": "أضف ملاحظة اختيارية تصاحب قرارك...",
    "approveAndSign": "اعتماد وتوقيع التأكيد",
    "rejectRequest": "رفض الطلب",
    "employeeName": "اسم الموظف",
    "employeeId": "الرقم الوظيفي",
    "companyEmail": "البريد الإلكتروني للشركة",
    "sendConfirmationToClient": "إرسال التأكيد إلى العميل",
    "sendConfirmationDesc": "سيؤدي هذا إلى إنشاء مستند تأكيد HTML منسق بدقة وإرساله مباشرةً إلى البريد الإلكتروني الخاص بفواتير العميل.",
    "recipientEmailAddress": "عنوان البريد الإلكتروني للمستلم",
    "sendEmail": "إرسال البريد",
    "sending": "جارٍ الإرسال...",
    "confirmationSent": "تم إرسال التأكيد!",
    "confirmationSentDesc": "تم إرسال البريد الإلكتروني للتأكيد بنجاح إلى",
    "paymentPhotoPdf": "صورة إيصال التحويل / مستند PDF",
    "downloadImage": "تحميل الصورة",
    "areYouSure": "هل أنت متأكد؟",
    "confirmMarkPaid": "هل تريد تحديد هذا التأكيد كمدفوع بالكامل؟",
    "yesConfirm": "نعم، تأكيد",
    "confirmationMarkedAsPaid": "تم تحديد التأكيد كمدفوع!",
    "transactionRecorded": "تم تسجيل المعاملة المالية بنجاح في النظام.",
    "archiveRequestTitle": "أرشفة الطلب؟",
    "archiveRequestDesc": "هل أنت متأكد من رغبتك في أرشفة طلب الفاتورة هذا؟ لا يمكن التراجع عن هذا الإجراء.",
    "yesArchive": "نعم، أرشفة",
    "confirmationArchived": "تمت أرشفة طلب التأكيد!",
    "confirmationArchivedDesc": "تمت أرشفة طلب التأكيد بنجاح.",
    "provideRejectionReason": "تقديم سبب الرفض",
    "reasonOfRejection": "سبب الرفض",
    "rejectionReasonPlaceholder": "أدخل سبب رفض هذه الفاتورة..."
  },
  "companies": {
    "title": "دليل الشركات المتعاقدة",
    "subtitle": "إدارة بيانات الشركات الشريكة، والأرصدة الدائنة، وسجل المعاملات، وبيانات التواصل.",
    "addCompany": "إضافة شركة جديدة",
    "addNewCompany": "إضافة شركة جديدة",
    "editCompanyDetails": "تعديل بيانات الشركة",
    "companyDetails": "تفاصيل الشركة",
    "companyCode": "كود الشركة",
    "companyName": "اسم الشركة",
    "phoneNumber": "رقم الهاتف",
    "streetAddress": "عنوان الشارع",
    "city": "المدينة",
    "postalCode": "الرمز البريدي",
    "country": "الدولة",
    "taxIdentificationNumber": "الرقم التعريفي الضريبي",
    "agent": "الوكيل (Agent)",
    "noAgent": "لا يوجد وكيل",
    "unique3LetterIdentifier": "معرّف فريد من 3 أحرف",
    "creditBalance": "الرصيد الدائن المتاح",
    "resetCredit": "إعادة تعيين الرصيد",
    "resetCreditConfirm": "هل تريد إعادة تعيين الرصيد الدائن لـ {{name}} إلى 0.00 ر.س؟",
    "resetCreditSuccess": "تمت إعادة تعيين الرصيد الدائن إلى 0 بنجاح.",
    "address": "العنوان المعتمد",
    "cityCountry": "المدينة / الدولة",
    "taxNo": "الرقم الضريبي",
    "taxId": "الرقم الضريبي",
    "contactAgent": "الوكيل (Agent)",
    "searchPlaceholder": "البحث باسم الشركة، الكود، أو المدينة...",
    "financialReport": "التقرير المالي",
    "registeredRegions": "مسجلة عبر كافة المناطق",
    "corporate": "شركات",
    "showing": "عرض",
    "of": "من أصل",
    "registeredCompanies": "شركة مسجلة",
    "noCompaniesRegistered": "لا توجد شركات مسجلة بعد",
    "noCompaniesRegisteredDesc": "أضف أول شركة شريكة للبدء في إصدار الفواتير.",
    "noCompaniesFound": "لم يتم العثور على شركات",
    "noCompaniesFoundDesc": "حاول تعديل كلمات البحث الخاصة بك.",
    "nameRequired": "اسم الشركة مطلوب",
    "codeRequired": "كود الشركة مطلوب",
    "phoneRequired": "رقم الهاتف مطلوب",
    "addressRequired": "عنوان الشارع مطلوب",
    "cityRequired": "المدينة مطلوبة",
    "postalRequired": "الرمز البريدي مطلوب",
    "taxRequired": "الرقم الضريبي مطلوب",
    "codeAlreadyExists": "كود الشركة مستخدم بالفعل",
    "deleteCompany": "حذف الشركة",
    "deleteCompanyTitle": "حذف الشركة؟",
    "deleteCompanyConfirm": "هل أنت متأكد من رغبتك في حذف {{name}} ({{code}})? سيؤدي هذا إلى حذف الشركة نهائياً.",
    "yesDelete": "نعم، حذف",
    "editDetails": "تعديل التفاصيل",
    "saveChanges": "حفظ التغييرات",
    "companyFinancialReport": "التقرير المالي للشركة",
    "financialSummary": "الملخص المالي",
    "totalRevenue": "إجمالي الإيرادات",
    "netProfit": "صافي الأرباح",
    "outstanding": "المبالغ المستحقة غير المسددة",
    "monthlyFinancialOverview": "نظرة عامة على الأداء المالي الشهري",
    "companyFinancialBreakdown": "التفصيل المالي للشركات",
    "month": "الشهر",
    "revenue": "الإيرادات",
    "invoicesSent": "الفواتير المرسلة",
    "invoicesPaid": "الفواتير المسددة",
    "amountPaid": "المبلغ المسدد",
    "pending": "معلق",
    "overdue": "متأخر",
    "dataConsolidated": "البيانات مجمعة لكافة الشركات",
    "exportPdfReport": "تصدير تقرير PDF",
    "confirmAddCompany": "هل أنت متأكد من رغبتك في إضافة {{name}} إلى النظام؟",
    "successfullyDeleted": "تم الحذف بنجاح",
    "deletedDesc": "تمت إزالة {{name}} بنجاح من النظام.",
    "successfullyAdded": "تمت الإضافة بنجاح",
    "addedDesc": "تمت إضافة {{name}} إلى قائمة النظام بنجاح."
  },
    "hotelReservations": {
      "title": "حجوزات الفنادق",
      "subtitle": "متابعة قسائم حجز الفنادق وتسكين الغرف وتواريخ الوصول والمغادرة وتسديد العرابين.",
      "tabReservations": "قائمة الحجوزات",
      "tabRequests": "طلبات الحجز",
      "newReservation": "حجز فندقي جديد",
      "createTentative": "حجز مبدئي",
      "createConfirmation": "حجز مؤكد",
      "allReservations": "قائمة كافة الحجوزات",
      "searchPlaceholder": "البحث برقم الحجز، اسم النزيل، أو الفندق...",
      "totalBooked": "إجمالي المحجوز",
      "totalReservations": "إجمالي الحجوزات",
      "reservations": "حجز",
      "showing": "عرض",
      "hotel": "الفندق",
      "guestName": "اسم النزيل / العميل",
      "checkIn": "تسجيل الوصول",
      "checkOut": "تسجيل المغادرة",
      "rooms": "عدد الغرف",
      "roomType": "نوع الغرفة",
      "nights": "الليالي",
      "resNo": "رقم الحجز",
      "reqNo": "رقم الطلب",
      "amount": "المبلغ",
      "expiredPayment": "انتهت مهلة السداد",
      "manuallyCancelled": "ملغي يدوياً",
      "allRequests": "جميع الطلبات",
      "pendingRequests": "معلق",
      "confirmedRequests": "مؤكد",
      "rejectedRequests": "مرفوض",
      "noBookingsFound": "لم يتم العثور على حجوزات",
      "noBookingsFoundDesc": "لا توجد سجلات تطابق استفسارك.",
      "hotelReservationRequests": "طلبات حجز الفنادق",
      "request": "طلب",
      "backToListing": "العودة إلى القائمة",
      "confirmedReservationDetails": "تفاصيل الحجز المؤكد",
      "reservationDetails": "تفاصيل الحجز",
      "reservationNumber": "رقم الحجز",
      "invoiceNumber": "رقم الفاتورة",
      "referenceNumber": "رقم المرجع",
      "serialNumber": "الرقم التسلسلي",
      "dueDate": "تاريخ الاستحقاق",
      "billFrom": "فاتورة من",
      "billTo": "فاتورة إلى",
      "employeeName": "اسم الموظف",
      "companyNumber": "رقم الهاتف",
      "employeeId": "رقم الموظف",
      "companyEmail": "بريد الشركة الإلكتروني",
      "entityCompany": "الكيان / الشركة",
      "companyTaxNumber": "الرقم الضريبي للشركة",
      "clientCompany": "اسم الضيف / المجموعة",
      "guestGroupName": "اسم الضيف / المجموعة",
      "guestGroupNameRequired": "اسم الضيف / المجموعة مطلوب",
      "streetAddress": "عنوان الشارع",
      "cityCountry": "المدينة / الدولة",
      "accommodationsBreakdown": "تفاصيل الإقامة",
      "hotelDetails": "تفاصيل الفندق",
      "numNight": "عدد الليالي",
      "numRoom": "عدد الغرف",
      "adult": "بالغ",
      "child": "طفل",
      "meals": "الوجبات",
      "dayRate": "سعر اليوم",
      "mealsRate": "سعر الوجبات",
      "total": "الإجمالي",
      "subtotal": "المجموع الفرعي",
      "taxVat": "الضريبة / القيمة المضافة",
      "totalDue": "إجمالي المستحق",
      "remainingBalance": "الرصيد المتبقي",
      "advancePayment": "الدفعة المقدمة (عربون)",
      "hasAdvancePayment": "هل يوجد دفعة مقدمة؟",
      "advancePaymentAmount": "مبلغ الدفعة المقدمة",
      "exchangeRate": "سعر الصرف",
      "totalDueIdr": "إجمالي المستحق (إندونيسي)",
      "totalDueSar": "إجمالي المستحق (سعودي)",
      "paymentInstructions": "تعليمات الدفع",
      "bankName": "اسم البنك",
      "accountName": "اسم الحساب",
      "usdAccount": "حساب الدولار",
      "idrAccount": "حساب الروبية",
      "printInvoice": "طباعة الفاتورة",
      "downloadPdf": "تحميل PDF",
      "viewPdf": "عرض PDF",
      "approvalWorkflowStatus": "حالة سير عمل الموافقة",
      "madinahAccountant": "محاسب فرع المدينة",
      "confirmedAt": "تم التأكيد",
      "awaitingReviewYourLevel": "بانتظار المراجعة (مستواك)",
      "awaitingReview": "بانتظار المراجعة",
      "approvalsComplete": "اكتملت الموافقة — تم تأكيد الحجز",
      "approvalsPending": "قيد الانتظار — الحجز معلق",
      "readyForPayment": "جاهز لمعالجة الدفع",
      "availableOperations": "العمليات المتاحة",
      "paymentSettled": "✓ تم تسوية الدفعة بالكامل (مغلق)",
      "markAsPaid": "تحديد كمدفوع",
      "sendConfirmation": "إرسال التأكيد",
      "sendConfirmationRequest": "إرسال طلب التأكيد",
      "uploadPaymentInvoice": "رفع فاتورة / إثبات الدفع",
      "paymentProofRequired": "⚠️ إثبات الدفع مطلوب",
      "paymentProofUploaded": "تم رفع إثبات الدفع",
      "readyToReview": "جاهز للمراجعة",
      "viewProof": "عرض الإثبات",
      "changePaymentProof": "تغيير إثبات الدفع",
      "dragDropUpload": "اسحب وأفلت أو انقر للرفع",
      "uploadSupports": "يدعم: PDF, JPG, PNG (الحد الأقصى 10 ميجابايت)",
      "notes": "ملاحظات",
      "notesPlaceholder": "أضف ملاحظات الدفع أو تعليمات خاصة...",
      "saveNote": "حفظ الملاحظة",
      "yourDecision": "قرارك",
      "decisionDesc": "بصفتك محاسب المدينة، يرجى تأكيد التحقق من الحجز المطلوب.",
      "rejectRequest": "رفض الطلب",
      "approve": "موافقة",
      "confirmApproval": "تأكيد الموافقة",
      "confirmApprovalDesc": "يرجى إدخال رقم التأكيد للمتابعة في الموافقة على هذا الحجز.",
      "confirmAndApprove": "تأكيد وموافقة",
      "approvedSuccessfully": "تمت الموافقة بنجاح",
      "approvedSuccessfullyDesc": "تمت الموافقة على الحجز وتأكيده. تم إرسال إشعار إلى مقدم الطلب.",
      "paymentTransferPhotoPdf": "صورة / ملف تحويل الدفعة",
      "downloadImage": "تحميل الصورة",
      "addRoom": "إضافة غرفة",
      "createHotelReservation": "إنشاء حجز فندقي جديد",
      "stayType": "نوع الإقامة",
      "tentativeReservation": "حجز مبدئي",
      "confirmationReservation": "حجز مؤكد",
      "hotelName": "اسم الفندق",
      "hotelNamePlaceholder": "أدخل اسم الفندق (مثال: صفوة المدينة)",
      "checkInDate": "تاريخ تسجيل الوصول",
      "checkOutDate": "تاريخ تسجيل المغادرة",
      "nightsDuration": "عدد الليالي (المدة)",
      "adultsCount": "عدد البالغين",
      "childrenCount": "عدد الأطفال",
      "mealPlan": "خطة الوجبات",
      "pricePerNight": "سعر الليلة",
      "preview": "معاينة",
      "action": "إجراء",
      "createTentativeReservation": "إنشاء حجز مؤقت",
      "confNo": "رقم التأكيد",
      "confirmReservation": "تأكيد الحجز",
      "approvedByKarim": "معتمد من السيد كريم",
      "of": "من أصل",
      "billToClient": "فاتورة إلى (العميل)",
      "createNewHotelReservation": "إنشاء حجز فندقي جديد",
      "reservation": "حجز",
      "dayRatePricePerNight": "سعر اليوم (السعر / الليلة)",
      "advancePaymentPlaceholder": "أدخل مبلغ العربون...",
      "cifNumber": "رقم تعريف العميل / الشركة (CIF)",
      "swiftCode": "رمز سويفت (SWIFT)",
      "bankBranchAddress": "عنوان فرع البنك"
    },
  "settings": {
    "title": "إعدادات النظام",
    "subtitle": "إدارة صلاحيات المستخدمين، الفروع التشغيلية، إعدادات الإشعارات، والأمان.",
    "profile": "الملف الشخصي",
    "team": "إدارة فريق العمل",
    "branches": "الفروع التشغيلية",
    "notifications": "إعدادات الإشعارات",
    "security": "الأمان وكلمة المرور",
    "exchangeRates": "أسعار الصرف",
    "dataBackup": "النسخ الاحتياطي للبيانات",
    "services": "الخدمات",
    "companyInfo": "بيانات الشركة",
    "hbManagement": "إدارة غرف ووجبات الفنادق",
    "branchManagement": "إدارة الفروع والمكاتب",
    "locationAddress": "الموقع / العنوان",
    "branchName": "اسم الفرع",
    "addBranch": "إضافة فرع",
    "addMember": "إضافة عضو",
    "taxVatConfig": "إعدادات ضريبة القيمة المضافة",
    "taxVatSubtitle": "تحديد نسبة الضريبة الافتراضية المطبقة على التأكيدات المالية",
    "taxNumber": "الرقم الضريبي",
    "taxInfo": "المعلومات الضريبية",
    "taxInfoSubtitle": "تعيين الرقم الضريبي للشركة لاستخدامه في مستندات التأكيد",
    "bankInfo": "بيانات الحساب البنكي",
    "roomTypes": "أنواع الغرف",
    "mealPlans": "خطط الوجبات",
    "name": "الاسم بالكامل",
    "email": "البريد الإلكتروني",
    "phone": "رقم الهاتف / الجوال",
    "role": "المسمى والصلاحية",
    "password": "كلمة المرور",
    "newPassword": "كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور الجديدة",
    "downloadBackup": "تحميل نسخة احتياطية شاملة (.json)",
    "exportCsvData": "تصدير البيانات بصيغة (CSV)",
    "personalDetails": "البيانات الشخصية",
    "profileDisplayPicture": "صورة الحساب الشخصي",
    "photoGuidelines": "صيغ PNG أو JPG أو GIF حتى 5 ميجابايت. يُفضل 400×400 بكسل.",
    "changePhoto": "تغيير الصورة",
    "companyAssignment": "التبعية المؤسسية (للقراءة فقط)",
    "readOnly": "للقراءة فقط",
    "registeredCompany": "الشركة المسجلة",
    "defaultBranch": "الفرع التشغيلي الرئيسي",
    "employeeId": "الرقم الوظيفي",
    "department": "القسم الإداري",
    "jobTitle": "المسمى الوظيفي",
    "currentPassword": "كلمة المرور الحالية",
    "enterNewPassword": "أدخل كلمة المرور الجديدة",
    "reenterNewPassword": "أعد إدخال كلمة المرور الجديدة",
    "updatePassword": "تحديث كلمة المرور",
    "activeSessions": "جلسات المشغل النشطة",
    "loginActivityLogs": "سجل نشاط تسجيل الدخول (آخر 5 محاولات)",
    "timestamp": "الوقت والتاريخ",
    "ipAddress": "عنوان IP",
    "operatingAgent": "جهاز التشغيل",
    "revoke": "إلغاء الجلسة",
    "current": "الحالية",
    "confirmationNotifications": "إشعارات التأكيدات المالية",
    "approvalNotifications": "إشعارات مسار الموافقات",
    "systemNotifications": "إشعارات النظام والأمان",
    "alertType": "نوع التنبيه",
    "emailChannel": "البريد الإلكتروني",
    "inAppChannel": "داخل التطبيق",
    "notifNewInvoiceTitle": "تقديم تأكيد جديد",
    "notifNewInvoiceDesc": "إشعار عند قيام فريق الفرع بتقديم تأكيد جديد.",
    "notifApprovedTitle": "الموافقة على التأكيد",
    "notifApprovedDesc": "إشعار عند اجتياز التأكيد المراجعة النهائية واعتماده.",
    "notifRejectedTitle": "رفض التأكيد",
    "notifRejectedDesc": "إشعار في حال رفض التأكيد أو إعادته للتصحيح.",
    "notifPaymentTitle": "استلام الدفعة",
    "notifPaymentDesc": "إشعار عند نجاح تسجيل تحويلات الدفع.",
    "notifAssignedTitle": "إسناد طلب موافقة",
    "notifAssignedDesc": "تلقي تنبيهات عند وصول عنصر جديد إلى قائمة مهامك.",
    "notifApprovalDoneTitle": "اكتمال الموافقة",
    "notifApprovalDoneDesc": "إشعار عند قيام الفريق بمعالجة القوائم المعتمدة.",
    "notifApprovalOverdueTitle": "تأخر الموافقة عن الموعد",
    "notifApprovalOverdueDesc": "إشعار هام عند تجاوز عناصر قائمة الإجراءات للمهل المحددة.",
    "notifSecurityTitle": "تنبيهات الأمان",
    "notifSecurityDesc": "الحصول على إشعار بشأن محاولات الدخول من عناوين IP غير معروفة.",
    "notifTeamChangesTitle": "تغييرات أعضاء الفريق",
    "notifTeamChangesDesc": "إشعار عند إضافة أو إزالة مسؤولي النظام بواسطة المشرفين.",
    "notifMaintenanceTitle": "صيانة النظام",
    "notifMaintenanceDesc": "تنبيهات قبل التحديثات المجدولة للنظام وأوقات التوقف.",
    "dailyExchangeRate": "سعر الصرف اليومي للعملات",
    "exchangeRateSubtitle": "تحديث أسعار صرف العملات يدوياً لاحتساب التأكيدات المالية",
    "todayExchangeRate": "سعر صرف اليوم",
    "rateHistory": "سجل أسعار الصرف السابقة",
    "updated": "تم التحديث",
    "saveRates": "حفظ أسعار الصرف",
    "backupInfrastructure": "النسخ الاحتياطي للنظام وتصدير البنية التحتية",
    "backupSubtitle": "إنشاء وتنزيل لقطات احتياطية شاملة لقاعدة البيانات لأغراض الاسترداد دون اتصال.",
    "downloadFullBackup": "تحميل نسخة احتياطية كاملة (.json)",
    "fullBackupSubtitle": "يشمل التأكيدات، الحجوزات، دليل العملاء، والإعدادات",
    "generatingBackup": "جارٍ إنشاء النسخة الاحتياطية...",
    "autoCloudBackup": "النسخ الاحتياطي السحابي التلقائي",
    "activeSnapshot": "نشط (لقطة تلقائية)",
    "serverDeployments": "عمليات نشر الخادم",
    "synchronizedGit": "متزامن مع الفرع الرئيسي (Git Main)",
    "members": "الأعضاء",
    "addNewMember": "إضافة عضو فريق جديد",
    "editMember": "تعديل عضو الفريق",
    "deleteMember": "حذف عضو الفريق",
    "confirmDeletion": "تأكيد الحذف",
    "confirmDeletionDesc": "هل أنت متأكد أنك تريد إزالة {{name}} ({{email}}) من الفريق؟",
    "deleteWarning": "تحذير: لا يمكن التراجع عن هذا الإجراء. سيفقد هذا المستخدم جميع الصلاحيات فوراً.",
    "yesRemove": "نعم، حذف",
    "confirmAction": "تأكيد الإجراء",
    "confirmAddMember": "هل أنت متأكد أنك تريد إضافة هذا العضو؟",
    "confirmAddMemberDesc": "سيؤدي هذا الإجراء إلى إرسال بريد إلكتروني للدعوة إلى عضو الفريق الجديد.",
    "yesAddMember": "نعم، إضافة العضو",
    "memberAddedSuccess": "تمت إضافة العضو بنجاح!",
    "memberAddedSuccessDesc": "تمت إضافة عضو الفريق الجديد وإرسال رسالة البريد الإلكتروني.",
    "errorsFound": "تم العثور على {{count}} خطأ. يرجى تصحيحها قبل المتابعة.",
    "fullNameRequired": "الاسم الكامل مطلوب",
    "emailRequired": "عنوان البريد الإلكتروني مطلوب",
    "branchRequired": "الفرع مطلوب. يرجى إضافته في الإعدادات أولاً.",
    "autoGeneratedEmpId": "يتم إنشاؤه تلقائياً إذا تُرك فارغاً",
    "assignedBranch": "الفرع / المكتب المخصص",
    "rolesMatrix": "مصفوفة الأدوار والصلاحيات",
    "rolesMatrixSubtitle": "نظرة عامة على الصلاحيات الافتراضية لأدوار النظام",
    "permission": "الصلاحية",
    "createConfirmations": "إنشاء التأكيدات",
    "approveConfirmations": "اعتماد التأكيدات",
    "manageCompanies": "إدارة الشركات",
    "viewReports": "عرض التقارير",
    "manageTeam": "إدارة الفريق",
    "branchStats": "إحصائيات الفروع",
    "totalBranches": "إجمالي الفروع",
    "activeBranches": "الفروع النشطة",
    "totalStaffAcrossBranches": "إجمالي الموظفين في الفروع",
    "createBranch": "إنشاء فرع جديد",
    "createBranchSubtitle": "يحتوي الفرع على جميع سجلات العمليات الخاصة به.",
    "companyIdentity": "هوية الشركة",
    "companyIdentitySubtitle": "تحديث اسم شركتك المعروض في مستندات التأكيد",
    "contactInfo": "معلومات الاتصال",
    "contactInfoSubtitle": "تحديث رقم الهاتف وبيانات الاتصال الخاصة بالشركة",
    "defaultNotes": "الملاحظات الافتراضية",
    "defaultNotesSubtitle": "نص الملاحظات القياسي المضمن في أسفل مستندات التأكيد",
    "termsAndConditions": "الشروط والأحكام",
    "termsAndConditionsSubtitle": "شروط السداد القياسية المدرجة في التأكيدات",
    "bankAccountSubtitle": "إضافة تفاصيل الحسابات البنكية لشركتك",
    "bankName": "اسم البنك",
    "accountHolderName": "اسم صاحب الحساب",
    "idrAccountNumber": "رقم الحساب بالروبية (IDR)",
    "usdAccountNumber": "رقم الحساب بالدولار (USD)",
    "bankBranchAddress": "عنوان فرع البنك",
    "cifNumber": "رقم تعريف العميل / الشركة (CIF)",
    "swiftCode": "رمز سويفت (SWIFT)",
    "bankBranchAddressPlaceholder": "أدخل عنوان فرع البنك",
    "cifNumberPlaceholder": "أدخل رقم CIF أو رقم تعريف الشركة",
    "swiftCodePlaceholder": "أدخل رمز السويفت (مثال: BDINIDJA)",
    "roomTypeSubtitle": "إدارة أنواع غرف الفنادق القياسية المتاحة في النظام",
    "mealPlanSubtitle": "إدارة باقات الوجبات الفندقية المتاحة في النظام",
    "addRoomType": "إضافة نوع غرفة",
    "addMealPlan": "إضافة باقة وجبات",

    "roomTypeName": "اسم نوع الغرفة",
    "mealPlanName": "اسم باقة الوجبات",
    "mealPlanCode": "رمز باقة الوجبات",
    "exportHistory": "سجل التصدير",
    "exportType": "نوع التصدير",
    "filename": "اسم الملف",
    "exportedBy": "تم التصدير بواسطة",
    "fullBackupDesc": "تصدير حزمة JSON كاملة تحتوي على جميع قيود دفتر الأستاذ النشطة، وحجوزات الفنادق، ودليل العملاء، ومعاملات أسعار الصرف للأرشفة دون اتصال.",
    "noExportThisSession": "لا توجد عمليات تصدير في هذه الجلسة",
    "lastExport": "آخر تصدير: {{time}}",
    "hostingInfrastructure": "البنية التحتية للاستضافة والنسخ الاحتياطي لقاعدة البيانات",
    "productionDbDeployment": "قاعدة البيانات الإنتاجية ونشر خادم الويب",
    "authorizedControllers": "مسؤولو تكنولوجيا المعلومات المعتمدون",
    "cloudBackupNote": "* يتم تشغيل النسخ الاحتياطية السحابية التلقائية باستمرار على خادم قاعدة البيانات الإنتاجية النشط.",
    "adminItOnly": "لمسؤولي النظام وتكنولوجيا المعلومات فقط",
    "accessRestricted": "الوصول مقيد",
    "backupAccessRestrictedDesc": "هذا القسم الخاص بالنسخ الاحتياطي للنظام مقيد للغاية. يُصرح فقط للمشرف العام ومسؤولي تكنولوجيا المعلومات بالوصول إلى النسخ الاحتياطية وتنزيلها.",
    "exportCsvDesc": "تنزيل مجموعات البيانات الفردية المتوافقة مع Microsoft Excel و Google Sheets",
    "exportInvoicesDesc": "جميع قيود التأكيدات المالية",
    "exportReservationsDesc": "بيانات حجوزات الفنادق والغرف",
    "exportCompaniesDesc": "بيانات الشركات الشريكة والعملاء",
    "exportHistoryDesc": "سجل تدقيق عمليات تصدير البيانات. إذا فُقد الملف، انقر على \"إعادة التنزيل\" لاستخراج نسخة جديدة.",
    "redownload": "إعادة التنزيل",
    "redownloadDesc": "إعادة تنزيل هذه النسخة الاحتياطية",
    "noExportHistory": "لم يتم تسجيل أي سجل تصدير حتى الآن. يؤدي إنشاء نسخة احتياطية إلى تسجيل القيود هنا تلقائياً.",
    "loadingExportHistory": "جارٍ تحميل سجل التصدير...",
    "maintenanceBroadcastTitle": "بث صيانة النظام",
    "maintenanceBroadcastDesc": "إرسال إشعارات صيانة أو ترقية النظام لجميع المستخدمين فورياً.",
    "scopeLabel": "نطاق الصيانة المستهدف",
    "scopeAll": "كامل النظام (Full System)",
    "scopeReservations": "وحدة حجوزات الفنادق",
    "scopeInvoices": "وحدة الفواتير والمدفوعات",
    "scopeApprovals": "وحدة طلبات الاعتماد",
    "scopeSettings": "وحدة الإعدادات وقواعد البيانات",
    "scheduleTimeLabel": "جدول الصيانة (التاريخ والوقت)",
    "scheduleTimePlaceholder": "مثال: الليلة من 23:00 إلى 23:30 بتوقيت مكة",
    "urgencyLabel": "مستوى الأهمية",
    "urgencyNormal": "عادي (إشعار روتيني)",
    "urgencyHigh": "مرتفع (توقف مؤقت للنظام)",
    "messageLabel": "نص رسالة إعلان الصيانة",
    "messagePlaceholder": "اكتب تفاصيل الصيانة والتعليمات للمستخدمين أثناء فترة العمل...",
    "quickTemplates": "نماذج جاهزة",
    "tplServerUpgrade": "ترقية الخوادم وتحسين الأداء",
    "tplHotelModule": "صيانة وحدة حجوزات الفنادق",
    "tplDatabaseSync": "تحسين ومزامنة قواعد البيانات",
    "livePreview": "معاينة إشعار المستخدم",
    "sendBroadcastBtn": "إرسال البث الآن",
    "sendingBroadcast": "جارٍ الإرسال...",
    "confirmBroadcastTitle": "تأكيد إرسال بث الصيانة",
    "confirmBroadcastMsg": "هل أنت متأكد من إرسال هذا الإشعار لجميع حسابات المستخدمين؟ سيتم إرسال إشعار فوري داخل النظام وعبر البريد الإلكتروني.",
    "broadcastSuccess": "تم إرسال بث صيانة النظام لجميع المستخدمين بنجاح!",
    "maintenanceLocksTitle": "حالة صيانة الوحدات ومفاتيح القفل",
    "maintenanceLocksDesc": "قفل وصول المستخدمين العاديين أثناء أعمال الصيانة. يحتفظ فريق تقنية المعلومات (ديماس وعلي) بالوصول الكامل والتجاوز.",
    "bypassActive": "تجاوز تقنية المعلومات: نشط (ديماس وعلي)",
    "itBypassHeader": "قفل الصيانة نشط (صلاحية تجاوز لتقنية المعلومات)",
    "lockModuleBtn": "قفل هذه الوحدة",
    "unlockModuleBtn": "إلغاء قفل الوحدة",
    "lockSystemBtn": "قفل النظام بالكامل",
    "unlockSystemBtn": "إلغاء قفل النظام",
    "statusLocked": "مقفل",
    "statusActive": "نشط",
    "statusEmergencyLocked": "قفل طوارئ",
    "pageClosedForUsers": "الصفحة مغلقة للمستخدمين العاديين.",
    "pageNormalForUsers": "متاح بشكل طبيعي لجميع المستخدمين.",
    "systemClosedForUsers": "جميع الوحدات مقفلة باستثناء تسجيل الدخول وإعدادات تقنية المعلومات.",
    "systemNormalForUsers": "النظام بالكامل يعمل بشكل طبيعي.",
    "autoLockOnBroadcast": "قفل الوحدة المحددة فور إرسال البث",
    "maintenanceScreen": {
      "badge": "وضع الصيانة نشط",
      "closedTitle": "{{module}} مغلق مؤقتاً",
      "subtitle": "تخضع هذه الصفحة لعمليات صيانة أو ترقية للبنية التحتية من قبل فريق تقنية المعلومات.",
      "scheduleLabel": "التقدير / الجدول الزمني:",
      "detailsLabel": "التفاصيل:",
      "defaultMsg": "تجري تحديثات دورية للنظام للحفاظ على استقرار وسلامة البيانات.",
      "notice": "تم تعطيل الوصول إلى النماذج ومعالجة البيانات في هذه الوحدة مؤقتاً لتجنب تعارض البيانات. يرجى التواصل مع مسؤولي تقنية المعلومات (علي / ديماس) في حالات الطوارئ.",
      "backDashboard": "العودة إلى لوحة التحكم الرئيسية",
      "openInvoices": "فتح وحدة التأكيدات (الفواتير)"
    }
  },
  "auth": {
    "welcome": "مرحباً",
    "welcomeBack": "مرحباً بك مجدداً",
    "signInDesc": "قم بتسجيل الدخول إلى حسابك للمتابعة",
    "emailOrPhone": "البريد الإلكتروني أو رقم الهاتف",
    "enterPassword": "أدخل كلمة المرور الخاصة بك",
    "rememberMe": "تذكر بياناتي على هذا الجهاز",
    "forgotPassword": "هل نسيت كلمة المرور؟",
    "signIn": "تسجيل الدخول",
    "signingIn": "جارٍ تسجيل الدخول...",
    "resetPasswordTitle": "إعادة تعيين كلمة المرور",
    "resetPasswordDesc": "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.",
    "emailAddress": "عنوان البريد الإلكتروني",
    "enterEmail": "أدخل بريدك الإلكتروني",
    "sendResetLink": "إرسال رابط إعادة التعيين",
    "sending": "جارٍ الإرسال...",
    "backToSignIn": "العودة لتسجيل الدخول",
    "checkYourEmail": "تحقق من بريدك الإلكتروني",
    "resetLinkSent": "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى {{email}}. ستنتهي صلاحية الرابط خلال 30 دقيقة.",
    "didntReceiveEmail": "لم يصلك البريد الإلكتروني؟",
    "resend": "إعادة الإرسال",
    "resending": "جارٍ إعادة الإرسال...",
    "createNewPassword": "إنشاء كلمة مرور جديدة",
    "enterNewPasswordDesc": "يرجى إدخال كلمة المرور الجديدة أدناه.",
    "newPassword": "كلمة المرور الجديدة",
    "enterNewPassword": "أدخل كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور",
    "confirmNewPassword": "تأكيد كلمة المرور الجديدة",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "resetting": "جارٍ إعادة التعيين...",
    "resetCompleteTitle": "اكتملت إعادة تعيين كلمة المرور",
    "resetCompleteDesc": "تمت إعادة تعيين كلمة المرور الخاصة بك بنجاح. يمكنك الآن استخدام كلمة المرور الجديدة لتسجيل الدخول.",
    "emailOrPhoneRequired": "البريد الإلكتروني أو رقم الهاتف مطلوب",
    "validEmailRequired": "يرجى إدخال عنوان بريد إلكتروني صحيح",
    "passwordRequired": "كلمة المرور مطلوبة",
    "passwordMinLength": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    "passwordsDoNotMatch": "كلمات المرور غير متطابقة",
    "enterEmailRequired": "يرجى إدخال عنوان بريدك الإلكتروني",
    "tokenMissing": "رمز إعادة تعيين كلمة المرور مفقود. يرجى طلب رابط جديد.",
    "invalidCredentials": "بيانات الاعتماد غير صالحة. يرجى المحاولة مرة أخرى.",
    "failedToSendResetLink": "فشل إرسال رابط إعادة التعيين. يرجى المحاولة مرة أخرى.",
    "failedToResetPassword": "فشلت إعادة تعيين كلمة المرور. قد يكون الرمز غير صالح أو منتهي الصلاحية."
  },
  "expenses": {
    "title": "مصاريفي",
    "subtitle": "تتبع وتقديم وإدارة جميع مطالبات المصاريف المؤسسية وحالات استرداد النفقات الخاصة بك.",
    "submitNewClaim": "تقديم مطالبة جديدة",
    "exportExcel": "تصدير إلى Excel",
    "totalClaims": "إجمالي المطالبات",
    "pendingApproval": "قيد انتظار الموافقة",
    "approvedPayout": "معتمدة / جاهزة للصرف",
    "settledPaid": "تمت التسوية والدفع",
    "allClaims": "جميع المطالبات",
    "pending": "معلق",
    "approved": "معتمد",
    "paid": "مدفوع",
    "rejected": "مرفوض",
    "searchPlaceholder": "البحث برقم المطالبة أو الفئة أو الملاحظات...",
    "claimId": "رقم المطالبة",
    "date": "التاريخ",
    "category": "الفئة",
    "amount": "المبلغ",
    "bank": "الحساب البنكي المستلم",
    "approvalChain": "سلسلة الموافقات",
    "status": "الحالة",
    "receipt": "الإيصال المرفق",
    "actions": "الإجراءات",
    "viewDetail": "عرض التفاصيل",
    "viewTransferProof": "إيصال التحويل",
    "viewApprovalDetail": "مسار الاعتماد",
    "claimDetails": "تفاصيل المطالبة والمستندات",
    "receiptPreview": "معاينة مستند الإيصال",
    "noReceipts": "لا يوجد إيصال مرفق"
  },
  "submitExpense": {
    "title": "تقديم مطالبة بمصروفات العمل",
    "subtitle": "قم برفع الإيصالات والفواتير والمستندات المعتمدة لمراجعتها من قبل الإدارة والتدقيق المالي.",
    "dropzoneTitle": "اسحب وأفلت مستندات الإيصالات هنا أو اضغط للاختيار",
    "dropzoneHint": "الصيغ المدعومة: PDF, JPG, PNG, WEBP (الحد الأقصى 15 ميغابايت لكل ملف). يسمح برفع عدة ملفات معاً.",
    "category": "فئة المصروف",
    "selectCategory": "اختر الفئة...",
    "expenseDate": "تاريخ المصروف",
    "amount": "مبلغ المصروف",
    "currency": "العملة",
    "merchant": "اسم المورد / المحل",
    "taxVatId": "الرقم الضريبي (اختياري)",
    "purpose": "الغرض من المصروف / الوصف",
    "bankDestination": "الحساب البنكي لتحويل المبلغ",
    "selectBank": "اختر الحساب البنكي للموظف...",
    "submitClaim": "إرسال المطالبة للاعتماد",
    "submitting": "جارٍ إرسال المطالبة...",
    "successTitle": "تم تقديم مطالبة المصروف بنجاح!",
    "successDesc": "تم تسجيل مطالبتك بالرقم المرجعي {{id}} وتوجيهها إلى مديرك المباشر للمراجعة والاعتماد.",
    "trackClaim": "متابعة الحالة في مصاريفي"
  },
  "approvals": {
    "title": "لوحة متابعة واعتماد المصروفات",
    "subtitle": "تدقيق المطالبات المعتمدة، إعداد الصرف البنكي، التصدير إلى نظام تخطيط الموارد (ERP)، أو التسوية الفورية عبر واجهة البنك.",
    "pendingFinance": "بانتظار تدقيق المالية",
    "readyDisburse": "جاهزة للصرف الفوري",
    "totalValue": "إجمالي قيمة المطالبات",
    "processedMonth": "تمت معالجتها هذا الشهر",
    "addToPayroll": "إضافة إلى مسير الرواتب",
    "delete": "حذف",
    "deleteConfirmTitle": "حذف المطالبات المحددة",
    "deleteConfirmDesc": "هل أنت متأكد من رغبتك في حذف {{count}} من المطالبات المحددة؟ لا يمكن التراجع عن هذا الإجراء.",
    "deleteWarning": "سيؤدي هذا الإجراء إلى إزالة سجلات المطالبات المحددة نهائياً من قائمة الانتظار.",
    "exportAndSchedule": "تصدير إكسل وتأكيد",
    "transferToBank": "تحويل بنكي مباشر",
    "selectAll": "تحديد الكل",
    "batchAction": "إجراءات مجمعة",
    "employee": "الموظف",
    "department": "القسم",
    "reviewAudit": "مراجعة وتدقيق المطالبة",
    "payrollSuccess": "تمت الإضافة إلى دورة مسير الرواتب بنجاح",
    "bankSuccess": "تم بدء إجراءات التحويل البنكي بنجاح"
  },
  "expenseApproval": {
    "title": "تدقيق واعتماد المطالبة",
    "subtitle": "مراجعة ومعالجة مطالبة استرداد المصروف وتدقيق المستندات المرفقة.",
    "claimProfile": "ملف المطالبة",
    "workflowStepper": "مراحل سلسلة الاعتمادات",
    "workflowSubtitle": "سلسلة الاعتماد التنفيذي الثلاثي",
    "receiptView": "مستند الإيصال الرقمي",
    "vatSummary": "تفاصيل ضريبة القيمة المضافة",
    "transferAmount": "تحويل المبلغ",
    "rejectClaim": "رفض المطالبة",
    "requestClarification": "طلب توضيح",
    "approveClaim": "اعتماد المطالبة",
    "itMode": "وضع فحص واختبار تكنولوجيا المعلومات",
    "resetSimulation": "إعادة تعيين المحاكاة",
    "approverSimulation": "محاكاة صلاحية المعتمد:",
    "flowShortcuts": "اختصارات صفحات المسار:",
    "initiateReimbursementShortcut": "بدء إجراءات الصرف",
    "preExecutionPaymentShortcut": "الدفع قبل التنفيذ",
    "employeeBankDataShortcut": "بيانات الحساب البنكي للموظف",
    "fullItBypass": "تجاوز كامل للمطورين (Bypass)",
    "disbursedCompleteTitle": "تم الدفع والتسوية بالكامل",
    "disbursedCompleteDesc": "تم تحويل الأموال بنجاح إلى حساب {{name}} ({{bank}} - {{account}}).",
    "viewTransferProofAndAudit": "عرض إثبات التحويل وشهادة التدقيق",
    "accessDeniedApprover": "تم رفض الوصول: لست معتمداً رسمياً",
    "accessDeniedDesc": "يحق لـ 3 مسؤولين فقط اعتماد المطالبة (السيد هشام مختار، السيد خالد إدريس، والسيد عماد مصطفى). حسابات المشرف العام والموظفين الآخرين لا تملك صلاحية الاعتماد.",
    "notYourTurn": "ليس دورك في الاعتماد حالياً",
    "notYourTurnDesc": "تم تسجيل دخولك كـ {{name}}. ولكن اعتماد المرحلة {{step}} حالياً هو الصلاحية الحصرية لـ {{approver}} ({{role}}).",
    "yourTurn": "دورك في الاعتماد: {{name}}",
    "yourTurnDesc": "صلاحية اعتماد المرحلة {{step}} ({{role}}) مفعلة الآن.",
    "approveStage": "اعتماد المرحلة {{step}} ({{name}})",
    "fullyApprovedWaitingDisbursement": "تم اعتماد المطالبة بالكامل (اكتملت 3/3)",
    "fullyApprovedHoldNotice": "اكتمل الاعتماد التنفيذي ثلاثي المستويات. تم تعليق إجراءات الصرف البنكي الآلي مؤقتاً بانتظار استكمال الربط مع بنك BNI.",
    "approvalDisabledWaiting": "في انتظار اعتماد المرحلة {{step}} ({{approver}})",
    "approvalDisabledNoAuth": "الاعتماد معطل (يتطلب حساب معتمد مصرح له)",
    "claimClosedNotes": "تم اعتماد هذه المطالبة وتوثيقها في النظام المالي.",
    "noApprovalNotesPermitted": "لا يمكنك تقديم ملاحظات اعتماد في هذه المرحلة.",
    "approvalNotesPlaceholder": "أضف ملاحظات الاعتماد أو التعليمات في حال طلب توضيح...",
    "executionStatusLabel": "حالة التنفيذ",
    "executionStatusValue": "اكتمل الاعتماد التنفيذي 3/3",
    "cryptoValidationLabel": "التحقق المشفر",
    "cryptoValidationValue": "موثق ومشفر بـ SHA-256 غير قابل للتعديل",
    "claimArchivedLog": "تمت معالجة المطالبة بالكامل وتوثيقها في سجل التدقيق.",
    "statusTransferred": "الحالة: مسددة ومصروفة (Paid & Disbursed)",
    "statusTransferredDesc": "تمت معالجة هذه المطالبة بنجاح عبر التحويل البنكي المباشر Host-to-Host وتم إيداع المبلغ في حساب {{name}}.",
    "authorized": "معتمد ومصرح",
    "stageApprovedTitle": "تم اعتماد المرحلة {{step}}!",
    "fullyApprovedMsg": "تم اعتماد مطالبة الاسترداد {{claimId}} بالكامل (3/3) من قبل السيد عماد مصطفى.",
    "stepApprovedMsg": "تم تسجيل اعتماد المرحلة {{step}} ({{name}}) بنجاح. تم تحويل المطالبة إلى المرحلة التالية.",
    "accessDeniedTitle": "تم رفض الوصول",
    "accessDeniedRejectMsg": "لا تملك الصلاحية لرفض المطالبة في هذه المرحلة.",
    "accessDeniedClarifyMsg": "لا تملك الصلاحية لطلب توضيح في هذه المرحلة.",
    "accessDeniedDisburseMsg": "يحق فقط للسيد عماد مصطفى (المراقب المالي / الخزينة) بدء إجراءات الصرف البنكي.",
    "claimRejectedTitle": "تم رفض المطالبة",
    "claimRejectedMsg": "تم رفض مطالبة استرداد المصروف {{claimId}}.",
    "clarificationRequestedTitle": "تم طلب توضيح",
    "clarificationRequestedMsg": "تم إرسال إشعار إلى {{name}} لطلب تفاصيل إضافية.",
    "fullSettled": "مسدد بالكامل"
  },
  "initiateReimbursement": {
    "title": "بدء إجراءات الصرف البنكي",
    "subtitle": "مراجعة ملخص المطالبة، واختيار حساب السحب للشركة، وتفعيل الصرف الآلي عبر واجهة البنك Host-to-Host.",
    "claimSummary": "ملخص المطالبة المعتمدة",
    "fundingSource": "حساب السحب للشركة",
    "beneficiaryDetails": "بيانات الحساب البنكي للمستفيد",
    "attentionController": "تنبيه المراقب المالي",
    "attentionDesc": "بالنقر على بدء الدفع أدناه، فإنك تفوض بالصرف الفوري للأموال إلى الحساب البنكي المعتمد للموظف والموضح أعلاه.",
    "initiatePayment": "بدء عملية الدفع",
    "cancelExecution": "إلغاء العملية",
    "verifiedAccount": "حساب موثق",
    "transferToBank": "التحويل البنكي المباشر",
    "apiIntegrated": "مفعّل • متصل عبر الـ API",
    "apiInactive": "غير مفعّل • غير متصل بالـ API",
    "transferDesc": "بدء تسوية تحويل بنكي محلي فوري عبر مسار Host-to-Host الآلي (SNAP BI).",
    "gatewayCallout": "متصل مباشرة ببوابة {{bank}} (SNAP BI TLS 1.3). تم التحقق من رصيد حساب الشركة.",
    "gatewayInactiveCallout": "بوابة {{bank}} غير مفعلة حالياً أو لم يتم تهيئتها بعد. يرجى التواصل مع المشرف التقني للتفعيل.",
    "gatewayInactiveWarning": "تم تعليق مسار التحويل البنكي الآلي لأن حالة البوابة غير مفعلة.",
    "disbursedAlertTitle": "الحالة: تم تحويل الأموال وتسويتها بنجاح",
    "disbursedAlertDesc": "تمت معالجة معاملة الدفع لهذه المطالبة بنجاح إلى حساب المستفيد الموضح أعلاه. تم تعطيل الدفع المتكرر لدواعي الأمان.",
    "viewTransferProofAndAudit": "عرض إثبات التحويل وسجل التدقيق"
  },
  "setupBeneficiary": {
    "title": "إعداد وتوثيق حساب المستفيد",
    "subtitle": "تهيئة وتوثيق بيانات الحساب البنكي للموظف للتحويلات التلقائية المباشرة عبر واجهة الربط المصرفي (SNAP BI).",
    "clearingDomestic": "شبكة المقاصة المحلية لبنك إندونيسيا (SNAP BI / BI-FAST TLS 1.3)",
    "clearingInternational": "شبكة المقاصة الدولية والسعودية السريعة (سريع SARIE)",
    "bankName": "اسم البنك",
    "targetCurrency": "العملة المستهدفة",
    "accountHolder": "اسم صاحب الحساب",
    "accountHolderNote": "يجب أن يتطابق مع الاسم المسجل رسمياً في الهوية الوطنية / كشف الحساب البنكي.",
    "accountNumber": "رقم الحساب",
    "accountNumberPlaceholder": "رقم حساب {{bank}} ({{min}}-{{max}} خانة)",
    "checkAccount": "الاستعلام والتحقق من الحساب",
    "checkingAccount": "جاري الاستعلام من البنك...",
    "accountVerifiedOfficial": "موثق رسمياً عبر {{network}}",
    "accountNameMatched": "الاسم المسجل في البنك: {{name}}",
    "accountStatusActive": "حالة الحساب: نشط",
    "accountNotFound": "رقم الحساب {{account}} غير موجود أو غير نشط في خادم {{bank}} (رمز الاستجابة: 404 ACCOUNT_NOT_FOUND). يرجى إدخال رقم حساب حقيقي وصحيح.",
    "accountInquiryFailed": "فشل الاتصال ببوابة الاستعلام المصرفي.",
    "formatValid": "صيغة رقم الحساب صحيحة ({{min}}-{{max}} خانة)",
    "iban": "رقم الآيبان IBAN (24 خانة)",
    "ibanOptional": "الآيبان (غير مطلوب للتحويلات المحلية داخل إندونيسيا)",
    "ibanOptionalPlaceholder": "غير مطلوب للتحويلات البنكية المحلية داخل إندونيسيا (اختياري)",
    "ibanRequired": "الآيبان إلزامي 24 خانة (صيغة المملكة العربية السعودية)",
    "ibanValid": "رقم الآيبان المكون من 24 خانة صحيح",
    "ibanInvalid": "يجب أن يتكون الآيبان من 24 خانة تماماً (يبدأ بـ SA)",
    "swift": "رمز السويفت SWIFT / BIC",
    "branchLocation": "فرع البنك / الموقع",
    "saveAccount": "حفظ وتوثيق بيانات الحساب",
    "accountVerified": "تم توثيق حساب المستفيد بنجاح!",
    "modalVerifiedDesc": "تم التحقق من بيانات الحساب البنكي للمستفيد {{name}} في {{bank}} وحفظها للتسوية والصرف الفوري.",
    "proceedToReimbursement": "المتابعة إلى صرف المطالبة"
  },
  "preExecutionPayment": {
    "reviewTitle": "مراجعة الدفع قبل التنفيذ",
    "reviewSubtitle": "إجراء التحقق الثنائي (2FA). التأكد من مطابقة سجل التدقيق لمعايير الحوكمة المؤسسية المعتمدة.",
    "tunnelTitle": "قناة التسوية البنكية المباشرة (API Tunnel)",
    "tunnelSubtitle": "المصافحة والاتصال الآمن Host-to-Host مع واجهة البنك.",
    "dispatchedTitle": "تم إرسال الدفعة بنجاح",
    "dispatchedSubtitle": "تم توجيه الأموال بنجاح وتأكيدها من قبل بوابة البنك. تم إنشاء مستندات التدقيق المالي.",
    "confirmAuthorize": "تأكيد وتفويض التحويل",
    "enterOtp": "أدخل رمز التحقق (OTP)",
    "otpPlaceholder": "رمز من 6 أرقام",
    "settlePaid": "تم السداد بالكامل",
    "downloadVoucher": "تحميل إيصال PDF",
    "auditTrail": "سجل التدقيق المالي ومطابقة الامتثال",
    "exportCertificate": "تصدير شهادة التدقيق الكاملة",
    "copyHash": "نسخ الرمز المشفر للتدقيق",
    "hashCopied": "تم نسخ الرمز!",
    "inspect": "فحص التفاصيل",
    "stepOf": "الخطوة {{current}} من {{total}}",
    "verifiedImmutable": "موثق وغير قابل للتعديل",
    "authorizedSigner": "المخول بالاعتماد / البوابة",
    "authProof": "إثبات التحقق والهوية",
    "telemetry": "بيانات التتبع وسجل الشبكة",
    "digitalSignature": "التوقيع الرقمي المشفر SHA-256",
    "governancePolicy": "مطابقة سياسات الحوكمة والامتثال",
    "signerRemarks": "ملاحظات الاعتماد والتنفيذ",
    "closeInspector": "إغلاق نافذة الفحص",
    "nextStep": "الخطوة التالية",
    "prevStep": "الخطوة السابقة",
    "realtimeLifecycle": "دورة حياة إرسال الـ API في الوقت الفعلي",
    "apiHandshake": "مصافحة الـ API",
    "balanceVerified": "تم التحقق من الرصيد",
    "dispatching": "جارٍ الإرسال",
    "traceIdLabel": "معرف تتبع المعاملة",
    "settlementEndpoint": "نقطة نهاية التسوية",
    "estimatedCompletion": "الوقت التقديري للاكتمال",
    "under30Sec": "أقل من 30 ثانية",
    "autoRefreshWarning": "يتم تحديث هذه اللوحة تلقائياً. يرجى عدم إعادة تحميل الصفحة أو مغادرتها.",
    "otpSentTo": "تم إرسال رمز التحقق (OTP) إلى الهاتف المحمول لـ {{chiefAccountant}} ({{chiefAccountantRole}}) و {{controller}} ({{controllerRole}}).",
    "resendCodeSec": "إعادة إرسال الرمز ({{sec}} ث)",
    "resendCodeNow": "إعادة إرسال الرمز الآن",
    "verifyInvoiceCheckbox": "أقر بأن تفاصيل المعاملة المذكورة أعلاه موثقة وجاهزة للتحويل بمبلغ {{amount}}.",
    "debitAccountSender": "حساب الخصم (المرسل)",
    "creditAccountRecipient": "حساب الإيداع (المستفيد)",
    "settlementRoute": "مسار التسوية",
    "estimatedSpeed": "السرعة التقديرية",
    "backToClaim": "العودة إلى المطالبة",
    "stepMsg1": "جارٍ بدء معاملة الدفع للمطالبة {{claim}}...",
    "stepMsg2": "إجراء مصافحة mTLS 1.3 مع بوابة {{bank}}...",
    "stepMsg3": "التحقق من تفويض رصيد وحدود حساب الشركة...",
    "stepMsg4": "تحويل الأموال Host-to-Host مباشرة إلى {{employee}} ({{bank}})...",
    "stepMsg5": "تم التحويل بنجاح! جارٍ إعداد مستند الصرف..."
  },
  "superAdmin": {
    "badge": "المشرف العام",
    "title": "لوحة تحكم المشرف العام",
    "subtitle": "إدارة صلاحيات المستخدمين، ومراقبة سجلات التدقيق، والنسخ الاحتياطي للنظام.",
    "refreshData": "تحديث البيانات",
    "restrictedTitle": "الوصول مقيد",
    "restrictedDesc": "لوحة تحكم المشرف العام مخصصة حصرياً لمديري النظام (ديماس وعلي). حسابك الحالي لا يملك الصلاحية للوصول إلى هذه اللوحة.",
    "returnToDashboard": "العودة للوحة التحكم",
    "tabs": {
      "permissionMatrix": "مصفوفة الصلاحيات",
      "users": "مستخدم",
      "auditLogs": "سجلات تدقيق النظام",
      "dataBackup": "النسخ الاحتياطي للبيانات",
      "systemMaintenance": "صيانة النظام",
      "bankingApi": "بوابة الـ API والخدمات المصرفية"
    },
    "bankingApi": {
      "metrics": {
        "snapBiTitle": "SNAP BI",
        "snapBiDesc": "معيار Open API للبنك المركزي الإندونيسي",
        "tlsTitle": "إلزامي TLS 1.3",
        "tlsDesc": "PADG BI No. 23/15/PADG/2021",
        "latencyDesc": "زمن استجابة BNI H2H",
        "shaTitle": "SHA-256 / RSA",
        "shaDesc": "توقيع رقمي غير متماثل"
      },
      "form": {
        "title": "إعداد المعلمات: {{name}}",
        "subtitle": "تهيئة بيانات اعتماد Host-to-Host، والرابط الأساسي، وWebhook للتكامل المباشر مع البنك.",
        "testPing": "اختبار الاتصال (Ping)",
        "testing": "جارٍ الاختبار...",
        "gatewayName": "اسم البوابة",
        "gatewayCode": "رمز البوابة",
        "environment": "بيئة التشغيل",
        "envSandbox": "بيئة تجريبية (Sandbox)",
        "envProduction": "بيئة الإنتاج المباشرة (Production)",
        "operationalStatus": "الحالة التشغيلية",
        "active": "مفعّل",
        "inactive": "معطّل",
        "clientId": "معرف العميل / مفتاح الـ API",
        "clientSecret": "الرمز السري للعميل (Client Secret)",
        "show": "عرض",
        "hide": "إخفاء",
        "merchantCode": "رمز التاجر (Merchant Code)",
        "channelId": "معرف القناة (Channel ID)",
        "endpointUrl": "رابط نقطة النهاية (Host-to-Host)",
        "webhookUrl": "رابط الـ Webhook",
        "webhookSecret": "الرمز السري للـ Webhook",
        "ipWhitelist": "قائمة عناوين IP المسموح بها",
        "certificateData": "شهادة mTLS العامة (PEM)",
        "saveConfig": "حفظ الإعدادات",
        "saving": "جارٍ الحفظ..."
      },
      "diagnostics": {
        "title": "نتائج اختبار اتصال SNAP BI",
        "standardNote": "PADG BI No. 23/15/PADG/2021",
        "handshakeLatency": "زمن مصافحة الاتصال",
        "encryptionProtocol": "بروتوكول التشفير",
        "cipherSuite": "حزمة التشفير (Cipher Suite)",
        "testTimestamp": "توقيت الفحص",
        "mandatory": "إلزامي"
      },
      "table": {
        "title": "سجل تدقيق وإرسال التسويات البنكية",
        "subtitle": "سجلات حية لتنفيذ تحويلات الأموال من قاعدة بيانات dst_audit_logs.",
        "colTimestamp": "التاريخ والوقت",
        "colExecutor": "المنفّذ",
        "colAction": "الإجراء",
        "colTarget": "المستهدف / المستفيد",
        "colTraceId": "معرف التتبع (Trace ID)",
        "noAuditLogs": "لم يتم تسجيل أي سجلات تسوية بنكية بعد.",
        "settlementBadge": "تسوية بنكية"
      },
      "feedback": {
        "saveSuccess": "تم حفظ إعدادات الـ API الخاصة بـ {{name}} بنجاح في قاعدة البيانات!",
        "saveError": "فشل في حفظ إعدادات بوابة البنك.",
        "pingSuccess": "نجح اختبار المصافحة ({{ms}} مللي ثانية) - الحالة: متصل (ONLINE).",
        "pingError": "فشل الاتصال ببوابة واجهة البنك.",
        "loading": "جارٍ تحميل بيانات تكامل الـ API..."
      }
    },
    "stats": {
      "totalUsers": "إجمالي المستخدمين",
      "bypassApproved": "تجاوز الاعتماد مفعل",
      "canAddMembers": "إضافة الأعضاء",
      "superAdmins": "المشرفون العامون"
    },
    "searchPlaceholder": "البحث بالاسم، البريد الإلكتروني، الدور، أو الفرع...",
    "filterLabel": "تصفية:",
    "filters": {
      "allUsers": "جميع المستخدمين",
      "bypassEnabled": "تجاوز الاعتماد مفعّل",
      "superAdmins": "المشرفون العامون"
    },
    "table": {
      "userRole": "المستخدم والدور",
      "branchDept": "الفرع / القسم",
      "bypassApproval": "تجاوز الاعتماد",
      "addMembers": "إضافة أعضاء",
      "manageLogs": "إدارة السجلات",
      "viewReports": "عرض التقارير",
      "noUsers": "لم يتم العثور على أعضاء مطابقين.",
      "role": "الدور:",
      "globalOffice": "المكتب الرئيسي",
      "enabled": "مفعّل",
      "disabled": "معطّل",
      "superAdminBadge": "مشرف عام",
      "vipBadge": "VIP"
    },
    "feedback": {
      "updatedPerm": "تم تحديث الصلاحية \"{{key}}\" للمستخدم {{name}} إلى {{status}}.",
      "updateFailed": "فشل في تحديث الصلاحية للمستخدم {{name}}.",
      "manualLogRecorded": "تم تسجيل ملاحظة التدقيق اليدوية بنجاح.",
      "logUpdated": "تم تحديث سجل التدقيق بنجاح.",
      "logDeleted": "تم حذف سجل التدقيق نهائياً.",
      "logsLoadFailed": "فشل في تحميل سجلات التدقيق. تأكد من تسجيل الدخول كمشرف عام.",
      "deleteFailed": "فشل في حذف سجل التدقيق."
    },
    "audit": {
      "searchPlaceholder": "بحث السجلات بالمستخدم، الإجراء، عنوان IP أو التفاصيل...",
      "allActions": "جميع الإجراءات",
      "filterBypass": "تأكيدات التجاوز",
      "filterPerms": "تغيير الصلاحيات",
      "filterAdminNotes": "ملاحظات الإدارة",
      "filterSecurity": "أحداث الأمان",
      "filterSystem": "تغييرات النظام",
      "addManualLog": "إضافة سجل يدوي",
      "timestamp": "التاريخ والوقت",
      "actionEvent": "نوع الإجراء",
      "performedBy": "تم بواسطة",
      "targetEntity": "الجهة المستهدفة",
      "remarksDetails": "تفاصيل وملاحظات التدقيق",
      "actions": "الإجراءات",
      "loading": "جارٍ تحميل سجلات تدقيق النظام...",
      "noLogs": "لا توجد سجلات تدقيق مطابقة لمعايير البحث.",
      "editTooltip": "تعديل ملاحظات السجل",
      "deleteTooltip": "حذف السجل",
      "deleteTitle": "حذف سجل التدقيق؟",
      "deleteDesc": "هل أنت متأكد من رغبتك في حذف سجل التدقيق رقم: {{id}} نهائياً؟ لا يمكن التراجع عن هذا الإجراء.",
      "confirmDelete": "نعم، حذف",
      "dismiss": "إغلاق",
      "badges": {
        "bypass": "تجاوز التأكيد",
        "updatePerms": "تحديث الصلاحيات",
        "adminNote": "ملاحظة إدارية"
      }
    },
    "modal": {
      "addTitle": "إضافة سجل تدقيق للنظام",
      "editTitle": "تعديل سجل التدقيق",
      "addSubtitle": "تسجيل ملاحظة تدقيق تشغيلية",
      "editSubtitle": "رقم السجل: {{id}}",
      "actionLabel": "نوع الإجراء / الحدث *",
      "targetLabel": "المستخدم / الكيان المستهدف",
      "targetPlaceholder": "مثال: Mr. Khalid, DST-System, finance_token",
      "ipLabel": "عنوان IP (اختياري)",
      "ipPlaceholder": "مثال: 187.52.126.215 أو 127.0.0.1",
      "remarksLabel": "ملاحظات وتفاصيل التدقيق *",
      "remarksPlaceholder": "أدخل الملاحظات الخاصة بمسار التدقيق هذا...",
      "save": "إضافة سجل تدقيق",
      "update": "تحديث السجل",
      "saving": "جارٍ الحفظ...",
      "options": {
        "manual": "ملاحظة إدارية يدوية",
        "security": "تدقيق الأمان والوصول",
        "sysConfig": "تغيير إعدادات النظام",
        "updatePerms": "تحديث صلاحيات المستخدم",
        "financeOverride": "تجاوز معاملة مالية",
        "compliance": "مراجعة الامتثال والتدقيق"
      },
      "errorEmpty": "يرجى تقديم تفاصيل أو ملاحظات لسجل التدقيق هذا."
    }
  },
  "depositReceipt": {
    "generateTitle": "إصدار سند قبض دفعة مقدمة رسمي",
    "generateSubtitle": "سند قبض نقدي ومصرفي مباشر مع مطابقة الحسابات البنكية لكلا الشركتين",
    "receiptTitle": "سند قبض رسمي للدفعة المقدمة",
    "receiptSubtitle": "المملكة العربية السعودية / جمهورية إندونيسيا",
    "receiptVoucher": "سند قبض استلام مبالغ مالية",
    "receiptNo": "رقم السند",
    "date": "تاريخ السند",
    "confirmationDate": "تاريخ التأكيد",
    "referenceNo": "الرقم المرجعي",
    "serialNo": "الرقم التسلسلي",
    "groupNo": "رقم المجموعة",
    "payerInfo": "بيانات الشركة الدافعة / العميل",
    "selectRegisteredPayer": "اختر شركة مسجلة",
    "orCustomPayer": "عميل مخصص / لمرة واحدة",
    "payerCompanyName": "اسم الشركة الدافعة",
    "payerCode": "رمز الشركة",
    "payerAgent": "الوكيل / الشخص المسؤول",
    "payerAddress": "عنوان الشركة",
    "payerTaxNumber": "الرقم الضريبي / السجل التجاري",
    "payerEmail": "البريد الإلكتروني",
    "paymentDetails": "تفاصيل المعاملة المالية",
    "depositAmount": "مبلغ الدفعة المقدمة",
    "currency": "العملة",
    "paymentDate": "تاريخ الدفع",
    "paymentMethod": "طريقة الدفع",
    "forPaymentOf": "وذلك عن (الغرض)",
    "purposePlaceholder": "مثال: دفعة مقدمة لحجوزات الفنادق والخدمات الأرضية",
    "notes": "ملاحظات داخلية",
    "note": "ملاحظات إضافية / المرجع",
    "notesPlaceholder": "ملاحظات إضافية...",
    "dualBankTitle": "بيانات التسوية البنكية لكلا الشركتين",
    "beneficiaryBank": "حساب البنك المستفيد (شركتنا)",
    "remitterBank": "حساب البنك المحوّل (الشركة الدافعة)",
    "bankName": "اسم البنك",
    "accountName": "اسم صاحب الحساب",
    "accountNumber": "رقم الحساب / الآيبان (IBAN)",
    "swiftCode": "رمز السويفت (SWIFT)",
    "bankBranch": "عنوان فرع البنك",
    "branch": "فرع البنك",
    "paymentProof": "إشعار التحويل / سند الدفع",
    "uploadProofDesc": "أرفق صورة التحويل أو مستند PDF",
    "dropFileHere": "انقر أو اسحب إشعار التحويل هنا",
    "previewProof": "معاينة الإشعار",
    "removeProof": "حذف",
    "submitGenerate": "إصدار ومعاينة السند الرسمي",
    "generating": "جارٍ إصدار السند...",
    "receivedFrom": "استلمنا من السادة",
    "amountInWords": "المبلغ كتابة (فقط)",
    "amountReceived": "المبلغ المقبوض",
    "settlementSummary": "تفاصيل الحسابات البنكية والتسوية",
    "authorizedSignature": "المحاسب المسؤول / المسؤول المالي",
    "stampAndSeal": "الختم الرسمي المعتمد",
    "printPdf": "طباعة / حفظ كـ PDF",
    "close": "إغلاق",
    "language": "لغة السند",
    "english": "الإنجليزية (English)",
    "indonesian": "الإندونيسية (Bahasa Indonesia)",
    "arabic": "العربية (Arabic)",
    "statusValid": "حالة النموذج: مكتمل ومتحقق منه",
    "errAmount": "يرجى إدخال مبلغ صحيح أكبر من صفر",
    "errPayer": "يرجى تحديد أو إدخال اسم الشركة الدافعة",
    "errBank": "يرجى تقديم تفاصيل الحسابات البنكية للمستفيد والمحول",
    "errProofSize": "حجم الملف يتجاوز الحد الأقصى 10 ميجابايت",
    "successGenerated": "تم إصدار سند القبض الرسمي بنجاح!"
  }
}

